import { z } from "zod/v4";

import { GoogleGaAudienceType } from "../schemas/google";

import { DefaultIntegrationGlobalSettingsDto } from "./integrations";

export const GoogleIntegrationPropertySchema = z.object({
  accountId: z.string(),
  propertyId: z.string(),
  streamId: z.string(),
  measurementId: z.string(),
});
export type GoogleIntegrationPropertyType = z.infer<
  typeof GoogleIntegrationPropertySchema
>;

export const GoogleGlobalSettingsDtoSchema = z.object({
  ga: GoogleIntegrationPropertySchema,
});

export interface GoogleInternalSettingsDto {
  ga?: {
    measurementSecret: string;
  };
}

export interface GoogleGlobalSettingsDto
  extends DefaultIntegrationGlobalSettingsDto {
  ga?: GoogleIntegrationPropertyType;
}

export interface GoogleExperienceSettingsType {
  ga: {
    audiences: GoogleGaAudienceType[];
  };
}
